import { toast } from 'sonner'
import { extractApiErrorMessages, extractApiErrorTitle } from '@/lib/apiError'

export function toastApiError(err: unknown, fallback: string): void {
  const messages = extractApiErrorMessages(err)
  if (messages.length === 0) {
    toast.error(extractApiErrorTitle(err) ?? fallback)
    return
  }
  if (messages.length === 1) {
    toast.error(messages[0])
    return
  }
  toast.error(extractApiErrorTitle(err) ?? fallback, {
    description: (
      <ul className="ml-4 list-disc space-y-0.5">
        {messages.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    ),
  })
}
